import React, { useState, useRef, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
// import { compose } from "recompose"
// import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Button, Box } from "@material-ui/core/"
import { closeResetPasswordDialog } from "actions/reset-password-dialog"
import DialogsContainerDialog from "../DialogsContainer"
import PhoneNumber from "./steps/PhoneNumber"
import Code from "./steps/Code"
import NewPassword from "./steps/NewPassword"
import LoaderButton from "../../components/LoaderButton"

const ResetPasswordDialog = ({ classes, fullScreen }) => {
  const formRef = useRef()
  const dispatch = useDispatch()
  const { open, loggedin } = useSelector(state => ({
    open: state.resetPasswordDialog.open,
    loggedin: state.resetPasswordDialog.loggedin
  }))
  const [resetData, setResetData] = useState({})
  const [currentStep, setCurrentStep] = useState(0)
  const [working, setWorking] = useState(false)

  useEffect(() => {
    if (loggedin) {
      setCurrentStep(2)
    } else {
      setCurrentStep(0)
    }
  }, [loggedin])

  const handleBack = val => {
    if (currentStep === 0 || loggedin || (val && val === "close")) {
      dispatch(closeResetPasswordDialog())
    }
    setCurrentStep(0)
  }
  const handleClose = () => {
    dispatch(closeResetPasswordDialog())
    setCurrentStep(0)
  }

  const handleStep = () => {
    setCurrentStep(currentStep + 1)
  }

  const handleNext = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const steps = [
    <PhoneNumber
      formRef={formRef}
      setWorking={setWorking}
      handleStep={handleStep}
    />,
    <Code
      formRef={formRef}
      setWorking={setWorking}
      handleStep={handleStep}
      setResetData={setResetData}
    />,
    <NewPassword
      formRef={formRef}
      setWorking={setWorking}
      handleStep={handleStep}
      resetData={resetData}
      handleClose={handleClose}
    />
  ]

  return (
    <DialogsContainerDialog
      fullScreen={fullScreen}
      open={open}
      handleClose={handleClose}
      title="Reset Password"
      content={<div>{steps[currentStep]}</div>}
      buttons={
        <div className={classes.buttonsContainer}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              onClick={handleBack}
              variant="text"
              className={classes.backButton}
            >
              {currentStep === 0 || loggedin ? "cancel" : "back"}
            </Button>
            <LoaderButton
              working={working}
              classes={{ button: classes.buttonNext }}
              onClick={handleNext}
              color="primary"
            >
              {currentStep === steps.length - 1 ? "Update" : "next"}
            </LoaderButton>
          </Box>
        </div>
      }
    />
  )
}

// export default withStyles(styles),
//   withMobileDialog()
// )(ResetPasswordDialog)
export default withStyles(styles)(ResetPasswordDialog)



// WEBPACK FOOTER //
// ./src/dialogs/ResetPassword/index.jsx